import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    objectId: String,
  }
  connect() {
    const taskIds = Array.from(
      this.element.closest('.board_list').querySelectorAll('.task_card')
    ).map(card => card.dataset.taskId);

    const frame = document.getElementById(`total_point_${this.objectIdValue}`);
    frame.src = `${frame.dataset.src}?task_ids[]=${taskIds.join('&task_ids[]=')}&object_id=${this.objectIdValue}`
  }
}